import React from 'react';
import styled from 'styled-components';
import { HeaderTitle } from '../../../utils/budget-tool-specific';
import BudgetForm from './budget-form';

const BudgetTool = (props) => {
    return (
        <PageContainer>
            <HeaderTitle>
                Budget Demo
            </HeaderTitle>
            <BudgetForm buttonAction="calculateRetreatCost" buttonLabel="Calculate Retreat Cost" id="budget-form"/>
        </PageContainer>
    )
}

export default BudgetTool;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;